import { render, staticRenderFns } from "./SysQuestionModel.vue?vue&type=template&id=6ace0d75&scoped=true"
import script from "./SysQuestionModel.vue?vue&type=script&lang=js"
export * from "./SysQuestionModel.vue?vue&type=script&lang=js"
import style0 from "./SysQuestionModel.vue?vue&type=style&index=0&id=6ace0d75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ace0d75",
  null
  
)

export default component.exports